import React from "react";
import { useNavigate } from "react-router-dom";
import { User, MapPin, Mail, LogOut, Calendar, Phone } from "lucide-react";
import { TopBar, BottomNav } from "../components/Nav";
import { useAuth } from "../context/AuthContext";
import { useLang } from "../i18n/LanguageContext";

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();

  return (
    <div className="min-h-screen bg-[#FDFBF7] pb-24 md:pb-10">
      <TopBar />
      <main className="max-w-2xl mx-auto px-4 sm:px-6 py-6">
        <div className="bg-white rounded-3xl border border-[#E5E0D8] p-6 sm:p-8 shadow-sm cd-fade-up" data-testid="profile-card">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-2xl bg-[#1B4332] flex items-center justify-center">
              <User className="w-8 h-8 text-[#D4A373]" />
            </div>
            <div>
              <h1 className="cd-heading text-2xl font-extrabold">{user?.name}</h1>
              <p className="text-sm text-[#52796F]">{t("profile.member")}</p>
            </div>
          </div>

          <div className="mt-6 space-y-3">
            {user?.email && (
              <InfoRow icon={<Mail className="w-4 h-4" />} label={t("auth.email")} value={user.email} testid="profile-email" />
            )}
            {user?.phone && (
              <InfoRow icon={<Phone className="w-4 h-4" />} label={t("auth.phone")} value={user.phone} testid="profile-phone" />
            )}
            {user?.location && (
              <InfoRow icon={<MapPin className="w-4 h-4" />} label={t("auth.location")} value={user.location} testid="profile-location" />
            )}
            {user?.created_at && (
              <InfoRow icon={<Calendar className="w-4 h-4" />} label={t("profile.joined")} value={new Date(user.created_at).toLocaleDateString()} testid="profile-joined" />
            )}
          </div>

          <button
            data-testid="profile-logout-btn"
            onClick={() => { logout(); nav("/"); }}
            className="mt-8 w-full bg-white text-[#D90429] border-2 border-[#D90429]/30 hover:bg-[#D90429]/5 py-3.5 rounded-full font-bold flex items-center justify-center gap-2 transition-colors"
          >
            <LogOut className="w-4 h-4" /> {t("common.logout")}
          </button>
        </div>
      </main>
      <BottomNav />
    </div>
  );
}

const InfoRow = ({ icon, label, value, testid }) => (
  <div data-testid={testid} className="flex items-center justify-between bg-[#F4F1EA] rounded-xl px-4 py-3">
    <div className="flex items-center gap-2 text-[#52796F] text-sm">{icon} {label}</div>
    <div className="font-semibold text-[#1C1C1C] text-sm">{value}</div>
  </div>
);
